import { filterLifeAreasBySearchText } from '@griply/utils';
import { useLocalizedLifeAreas } from 'features/life-areas';
import { useMemo } from 'react';

export const useTextFilteredLifeAreas = (searchText: string) => {
  const lifeAreas = useLocalizedLifeAreas();

  return useMemo(
    () => filterLifeAreasBySearchText(lifeAreas, searchText),
    [searchText, lifeAreas],
  );
};
